import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getCountryCodes = createAsyncThunk(
  "commonSlice/getCountryCode",
  async (_, { rejectWithValue }) => {
    
    try {
      const response = await getMethod(`/common/countryCodes`);
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "country code can not be fetched"
      );
    }
  }
);

const initialState = {
  codeLoading: false,
  success: false,
  countryCodes: [],
  error: {},
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountryCodes.pending, (state) => {
        state.codeLoading = true;
        state.success = false;
      })
      .addCase(getCountryCodes.fulfilled, (state, action) => {
        state.codeLoading = false;
        state.countryCodes = action.payload.data;
        state.success = true;
      })
      .addCase(getCountryCodes.rejected, (state,action) => {
        state.codeLoading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});


export default commonSlice.reducer; 